import UI from "components/UI";
import BaseEntity, {DataJobTypes} from "domain/BaseEntity";
import {toJS} from "mobx";
import {observer} from "mobx-react";
import {observable} from "mobx"
import React from "react";

export interface UIDataTableProps {
    dataList: BaseEntity[];
    rowNumber?: boolean;
    rowSortable?: boolean;
    thead?: React.ReactNode;
    columns: IDataTableColumn[];
    noDataMessage?: string;
    readOnly?: boolean;
}

export default observer(UIDataTable);

function UIDataTable(props: UIDataTableProps) {
    //props.noDataMessage = props.noDataMessage || "데이터가 없습니다.";
    const [selectedKeys, setSelectedKeys] = React.useState<{
        [key: string]: boolean;
    }>({});

    React.useEffect(
        () => {
            props.dataList.forEach((data) => {
                if (data.JOB_TYPES === null) {
                    data.set_JOB_TYPES(DataJobTypes.UPDATE);
                }
            });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [props.dataList]
    );

    let filteredList = observable(props.dataList.filter((data) => data.JOB_TYPES !== DataJobTypes.DELETE));

    const selectAll = (filteredList: BaseEntity[], select: boolean) => {
        const selectedKeys = {};

        filteredList.forEach((data) => {
            selectedKeys[data.KEY] = select;
        });

        setSelectedKeys(selectedKeys);
    };

    const isAllSelected = (filteredList: BaseEntity[]) => {
        if (filteredList.length === 0) {
            return false;
        }

        for (let i = 0; i < filteredList.length; i++) {
            if (!selectedKeys[filteredList[i].KEY]) {
                return false;
            }
        }

        return true;
    };

    return (
        <div className="tb mb10">
            <table>
                <colgroup>
                    {props.rowNumber && <col width="90px"/>}
                    {props.readOnly !== true &&
                        <col width="40px"/>}
                    {props.columns.map((column, index) => (
                        <col key={index} width={column.width}/>
                    ))}
                    {props.rowSortable && <col width="70px"/>}
                </colgroup>
                {props.thead != null ? (
                    props.thead
                ) : (
                    <thead>
                    <tr>
                        {props.rowNumber && <th>번호</th>}
                        {props.readOnly !== true && (
                            <th>
                                <UI.Checkbox value={isAllSelected(filteredList)}
                                             valueChanged={(value) => selectAll(filteredList, value)}/>
                            </th>
                        )}
                        {props.columns.map((column, index) => (
                            <th key={index}>
                                {column.title}
                            </th>
                        ))}
                        {props.rowSortable && <th>↑↓</th>}
                    </tr>
                    </thead>
                )}
                <tbody>
                {filteredList.length === 0 && (
                    <tr>
                        <td
                            colSpan={
                                props.columns.length +
                                (props.rowNumber ? 1 : 0) +
                                (props.readOnly !== true ? 0 : 1) +
                                (props.rowSortable ? 1 : 0)
                            }
                        >
                            {props.noDataMessage}
                        </td>
                    </tr>
                )}
                {filteredList.map((rowData, index) => {
                    return (
                        <tr key={rowData.KEY}>
                            {props.rowNumber && <td>{index+1}</td>}
                            {props.readOnly !== true && (
                                <td>
                                    <UI.Checkbox
                                        value={selectedKeys[rowData.KEY]}
                                        valueChanged={(value) => {
                                            setSelectedKeys({
                                                ...selectedKeys,
                                                [rowData.KEY]: value,
                                            });
                                        }}
                                    />
                                </td>
                            )}
                            {props.columns.map((column, index) => (
                                <td key={index} className={(column.align) && 'ta-'+column.align}>
                                    {typeof column.render === "function" && column.render(rowData, props.readOnly === true)}
                                </td>
                            ))}
                            {props.rowSortable && <td></td>}
                        </tr>
                    );
                })}

                </tbody>
            </table>
        </div>
    );
}

export interface IDataTableColumn {
    title?: string;
    width?: string;
    align?: "left" | "center" | "right";
    render?: (rowData: any, readOnly?: boolean) => React.ReactElement;
}
